import type { CardType, PortfolioItem } from "@pokifolio/contracts";

/** The card form's values, as typed (text boxes hold strings). */
export interface CardFormValues {
  readonly name: string;
  readonly setName: string;
  readonly cardNumber: string;
  readonly language: string;
  readonly cardType: CardType;
  readonly condition: string;
  readonly gradingCompany: string;
  readonly grade: string;
  readonly certificateNumber: string;
  readonly quantity: string;
  readonly purchasePrice: string;
  readonly purchaseCurrency: string;
  readonly purchaseDate: string;
  readonly boughtFrom: string;
  readonly storageLocation: string;
  readonly notes: string;
  readonly researchId: string | null;
}

export const EMPTY_CARD: CardFormValues = {
  name: "",
  setName: "",
  cardNumber: "",
  language: "",
  cardType: "raw",
  condition: "",
  gradingCompany: "",
  grade: "",
  certificateNumber: "",
  quantity: "1",
  purchasePrice: "",
  purchaseCurrency: "USD",
  purchaseDate: "",
  boughtFrom: "",
  storageLocation: "",
  notes: "",
  researchId: null,
};

/** A saved card → the form, for editing. */
export function valuesOf(item: PortfolioItem): CardFormValues {
  return {
    name: item.name,
    setName: item.setName ?? "",
    cardNumber: item.cardNumber ?? "",
    language: item.language ?? "",
    cardType: item.cardType,
    condition: item.condition ?? "",
    gradingCompany: item.gradingCompany ?? "",
    grade: item.grade === null ? "" : String(item.grade),
    certificateNumber: item.certificateNumber ?? "",
    quantity: String(item.quantity),
    purchasePrice: item.purchasePrice ?? "",
    purchaseCurrency: item.purchaseCurrency ?? "USD",
    purchaseDate: item.purchaseDate ?? "",
    boughtFrom: item.boughtFrom ?? "",
    storageLocation: item.storageLocation ?? "",
    notes: item.notes ?? "",
    researchId: item.researchId,
  };
}
